import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo-gray.svg';
import _imports_1 from '@/assets/master-link/wallet.svg';
import _imports_2 from '@/assets/icon/icon-menu-default.svg';
import _imports_3 from '@/assets/icon/icon-x-default.svg';

const _withScopeId = n => (_pushScopeId("data-v-6594fddc"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "nav-container"
};
const _hoisted_2 = {
  class: "wrapper"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "investNFT"
}, null, -1));

const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  class: "content-container tablet-hidden"
};
const _hoisted_6 = ["href"];
const _hoisted_7 = {
  class: "font-subtitle2"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cursor px-3 py-2 rounded-pill text-black bg-white lh-base font-subtitle2"
}, "前往登記", -1));

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon-rounded-wrapper"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "normal",
  src: _imports_1,
  alt: "user"
})], -1));

const _hoisted_10 = {
  class: "r-wrapper desktop-hidden-tablet"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon-rounded-wrapper"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "normal",
  src: _imports_1,
  alt: "user"
})], -1));

const _hoisted_12 = {
  key: 0,
  class: "menu desktop-hidden-tablet"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("a", {
  class: "nav-item-wrapper cursor first",
  href: `/#features`,
  style: {
    "text-decoration": "none",
    "height": "41px"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle1"
}, "關於 DemiHuman2.0")])], -1));

const _hoisted_14 = [_hoisted_13];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_user_selector = _resolveComponent("user-selector");

  const _component_connect_wallet_modal = _resolveComponent("connect-wallet-modal");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "logo-container",
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.navigate && _ctx.navigate(...args))
  }, _hoisted_4), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.navs, nav => {
    return _openBlock(), _createElementBlock("div", {
      key: nav.link
    }, [_createElementVNode("a", {
      class: "nav-item-wrapper cursor",
      href: nav.link,
      style: {
        "text-decoration": "none"
      }
    }, [_createElementVNode("span", _hoisted_7, _toDisplayString(nav.lable), 1)], 8, _hoisted_6)]);
  }), 128)), _hoisted_8, _createVNode(_component_user_selector, {
    list: $options.userList,
    avatar: $data.avatar
  }, {
    icon: _withCtx(() => [_hoisted_9]),
    _: 1
  }, 8, ["list", "avatar"])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_user_selector, {
    list: $options.userList,
    avatar: $data.avatar
  }, {
    icon: _withCtx(() => [_hoisted_11]),
    _: 1
  }, 8, ["list", "avatar"]), _createElementVNode("div", {
    class: "icon-rounded-wrapper toggle",
    onClick: _cache[1] || (_cache[1] = $event => $data.isToggle = !$data.isToggle)
  }, [_createElementVNode("img", {
    class: _normalizeClass(["type", {
      visible: !$data.isToggle
    }]),
    src: _imports_2,
    alt: "menu"
  }, null, 2), _createElementVNode("img", {
    class: _normalizeClass(["type", {
      visible: $data.isToggle
    }]),
    src: _imports_3,
    alt: "x"
  }, null, 2)])])]), $data.isToggle ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14)) : _createCommentVNode("", true)]), $data.isConnectWalletModalDisplay ? (_openBlock(), _createBlock(_component_connect_wallet_modal, {
    key: 0
  })) : _createCommentVNode("", true)], 64);
}